/* eslint-disable */
import api from '@/services/api';
import Vue from 'vue';
import Vuetify from '@/plugins/vuetify';

export default {
  async fetchLIs({ commit, dispatch }, payload) {
    const keys = Object.keys(payload);
    const params = new URLSearchParams();

    for (const key of keys) {
      if (payload[key]) {
        params.append(key, payload[key]);
      }
    }

    dispatch('toggleLoading', true, { root: true });

    const response = await api.get('/gestao-li', { params });
    commit('SET_LIS', response.data.data);
    commit('paginacao/SET_PAGINADOR', response.data, { root: true });

    dispatch('toggleLoading', false, { root: true });
  },
  limparLis({ commit }) {
    commit('SET_LIS', {});
  },
  async prepararExcel() {
    const { data  } = await api.get('/gestao-li/excel');

    return data;
  },
  async fetchItens({ commit }, codigoLI) {
    const { data: itens } = await api.get(`/gestao-li/${codigoLI}/itens`);

    commit('SET_ITENS', itens);
  },
  async fetchAnuencia({ commit }, codigoLI) {
    const { data: anuencia } = await api.get(`/gestao-li/${codigoLI}/anuencia`);

    commit('SET_ANUENCIA', anuencia);
  },
  async fetchDiferencaDias() {
    const { data: diferencaDias } = await api.get('/gestao-li/deferimento/diferenca-dias');

    return diferencaDias;
  },
  async filtrar({ commit }, payload) {
    return commit('SET_FILTROS', payload);
  },
  async baixarExtrato(_, payload) {
    try {
      const { codigoLI } = payload;

      const response = await api.get(`/gestao-li/extrato/${codigoLI}`, { responseType: 'arraybuffer' });

      const nomeArquivo = response.headers['content-disposition'].split('\"')[1];

      const blob = new Blob([response.data]);

      const link = document.createElement('a');

      link.href = URL.createObjectURL(blob);
      link.download = nomeArquivo;

      link.click();

      Vue.$toast.success(Vuetify.framework.lang.t('$vuetify.documentoBaixadoSucesso'));
    } catch (e) {
      Vue.$toast.error(Vuetify.framework.lang.t('$vuetify.erroBaixarDocumento'));
    }
  }
};
